<!-- eslint-disable @angular-eslint/template/no-call-expression -->
<div
  class="placeholder"
  *ngIf="showPlaceholder(); else content">
  <svg
    class="icon"
    viewBox="0 0 129 129">
    <path d="M8.7 4.5c-2.3 0-4.2 2-4.2 4.2v112.7l.5.8v.3s.2 0 .2.2l.5.6v.3c.2 0 .2 0 .3.2l.4.3h.2v.3c.2 0 .4 0 .5.2h.4l.2.2h112.8c2.3 0 4.2-1.8 4.2-4V8.7c0-2.4-2-4.3-4.2-4.3zM13 13h103.3v103H13zm21.3 27C32 40 30 42 30 44.2c0 2.3 2 4.2 4.3 4.2h60.4c2.4 0 4.2-2 4.2-4.2 0-2.4-2-4.2-4.4-4.2zm0 20.4c-2.4 0-4.2 1.8-4.2 4 0 2.5 2 4.3 4.4 4.3h60.4c2.4 0 4.2-1.8 4.2-4.2 0-2.3-2-4-4.3-4zm0 20.2c-2.4 0-4.2 2-4.2 4.2 0 2.4 2 4.2 4.4 4.2h30.2c2.3 0 4-1.8 4-4.2 0-2.3-1.7-4.2-4-4.2z" />
  </svg>
  <span>Texto</span>
</div>

<ng-template #content>
  <idt-common-styles-render
    *ngIf="piece"
    [styles]="styles">
    <div
      *ngIf="htmlContent"
      class="wysiwyg">
      <div class="wysiwyg-position">
        <render-wysiwyg
          [html]="htmlContent"
          [country]="country"
          [lang]="lang"
          [piece]="piece"
          [textPaddingTop]="settings?.general?.textPaddingTop"
          [textPaddingBottom]="settings?.general?.textPaddingBottom"
          [textPaddingLeft]="settings?.general?.textPaddingLeft"
          [textPaddingRight]="settings?.general?.textPaddingRight">
        </render-wysiwyg>
        <span
          *ngIf="isTextDropdownEnabled"
          class="show-more"
          role="button"
          (click)="type === 'render' ? showFullText=!showFullText : null">
          {{ toggleExpandedText }}
        </span>
      </div>
    </div>
  </idt-common-styles-render>
</ng-template>
